import { useI18n } from '@/contexts/I18nContext';
import { useTenant } from '@/contexts/TenantContext';

const FlagLanguageSwitcher = () => {
  const { locale, setLocale } = useI18n();
  const { currentTenant } = useTenant();

  const flags = [
    { 
      code: 'en' as const, 
      flag: '🇬🇧', 
      label: 'Switch to English',
      ariaLabel: 'Switch to English'
    },
    { 
      code: 'ar-AE' as const, 
      flag: '🇦🇪', 
      label: 'التبديل إلى العربية',
      ariaLabel: 'Switch to Arabic'
    },
    { 
      code: 'he' as const, 
      flag: '🇮🇱', 
      label: 'עבור לעברית',
      ariaLabel: 'Switch to Hebrew'
    },
  ];

  // Filter flags based on tenant's enabled languages
  const languagesEnabled = currentTenant?.languagesEnabled || { en: true, "ar-AE": false, "he": false };
  const enabledFlags = flags.filter((flag) => languagesEnabled[flag.code] !== false);

  console.log('🌍 Language Switcher Debug:', {
    currentTenant: currentTenant?.name,
    languagesEnabled,
    enabledFlags: enabledFlags.map(f => f.code),
    enabledCount: enabledFlags.length
  });

  // Don't show switcher if only one language is enabled
  if (enabledFlags.length <= 1) {
    console.log('⚠️ Language switcher hidden - only one language enabled');
    return null;
  }

  return (
    <div className="inline-flex items-center gap-2 bg-background/80 backdrop-blur-sm rounded-[12px] p-1 shadow-sm border border-border/50">
      {enabledFlags.map((flag) => {
        const isActive = locale === flag.code;
        return (
          <button
            key={flag.code}
            onClick={() => setLocale(flag.code)}
            aria-label={flag.ariaLabel}
            title={flag.label}
            className={`
              w-8 h-8 flex items-center justify-center text-2xl
              rounded-full transition-all duration-200
              hover:scale-110 hover:shadow-md
              ${isActive 
                ? 'ring-2 ring-primary shadow-md scale-105' 
                : 'opacity-60 hover:opacity-100'
              }
            `}
          >
            {flag.flag}
          </button>
        );
      })}
    </div>
  );
};

export default FlagLanguageSwitcher;
